import styled from 'styled-components';

// eslint-disable-next-line
export const SectionSuccess = styled.section.attrs({
  className: 's-success'
})`
  padding: ${({ theme }) => theme.indent.xxl} 0;

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    padding: ${({ theme }) => theme.indent.l} 0 ${({ theme }) => theme.indent.xl};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    padding: ${({ theme }) => theme.indent.m} 0 ${({ theme }) => theme.indent.l};
  }
`;
